import { FormControl, FormGroup } from '@angular/forms';

export const CONSTS = {
  HEADER: $localize`Building Scan Export`,
  DATE_LABEL: $localize`Date`,
  ROUTE_LABEL: $localize`Route`,
};

export const REPORT_FILE_NAME = 'Building-Scan-Report';

type BuildingScanFormField = {
  date: FormControl<Date>;
  routes: FormControl<string>;
};

export type BuildingScanFormGroup = FormGroup<BuildingScanFormField> | null;
